<template>
  <router-link
    v-if="link"
    :to="link"
    class="relatorio-card relatorio-card-link"
  >
    <div class="relatorio-card-mes">{{ mes }}</div>
    <div class="relatorio-card-ano">{{ ano }}</div>
  </router-link>
  <div v-else class="relatorio-card">
    <div class="relatorio-card-mes">{{ mes }}</div>
    <div class="relatorio-card-ano">{{ ano }}</div>
  </div>
</template>
<script>
export default {
  name: "RelatorioCard",
  props: {
    mes: {
      type: String,
      default: "",
    },
    ano: {
      type: String,
      default: "",
    },
    link: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.relatorio-card {
  width: 100%;
  border-radius: 5px;
  background: #fff;
  padding: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #6c757d;
  &:hover {
    @include shadow-basic();
  }
  .relatorio-card-mes {
    font-weight: 700;
  }
  .relatorio-card-ano {
  }
}
.relatorio-card-link {
  @include transition-all();
}
</style>
